export default {
  namespaced: true,

  state: {
    showOtherDonationWay: false,
    showDonationListGuideline: false,
  },

  mutations: {
    open(state, overlayName) {
      switch (overlayName) {
        case 'OtherDonationWay':
          state.showOtherDonationWay = true;
          break;
        case 'DonationListGuideline':
          state.showDonationListGuideline = true;
          break;
      }
    },

    close(state, overlayName) {
      switch (overlayName) {
        case 'OtherDonationWay':
          state.showOtherDonationWay = false;
          break;
        case 'DonationListGuideline':
          state.showDonationListGuideline = false;
          break;
      }
    },
  },
};
